import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton, Popover } from '@rtkwlf/fenrir-react';
import { faEllipsisV } from '@rtkwlf/pro-solid-svg-icons/faEllipsisV';
import { faRotate } from '@rtkwlf/pro-solid-svg-icons/faRotate';
import { useTranslation } from 'react-i18next';

import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@packages/fenrir/components';

export const EllipsisMenu = ({
  handleButtonCallback,
}: {
  handleButtonCallback: () => void;
}) => {
  const { t } = useTranslation('riskManagement', { keyPrefix: 'risks' });

  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <IconButton aria-label="open grid menu" color="primary">
          <FontAwesomeIcon icon={faEllipsisV} />
        </IconButton>
      </Popover.Trigger>
      <Popover.Content
        side="bottom"
        align="end"
        aria-labelledby="settingsPopOver"
      >
        <List sx={{ p: 0 }}>
          <ListItem disablePadding>
            <ListItemButton onClick={handleButtonCallback}>
              <ListItemIcon sx={{ minWidth: 16, mr: 1 }}>
                <FontAwesomeIcon
                  icon={faRotate}
                  color="var(--aw-palette-primary-main)"
                  aria-label="rotate"
                  size="sm"
                />
              </ListItemIcon>
              <ListItemText
                primary={t('updateRisk')}
                slotProps={{
                  primary: {
                    sx: {
                      color: 'var(--aw-palette-primary-main)',
                      fontSize: '14px',
                    },
                  },
                }}
              />
            </ListItemButton>
          </ListItem>
        </List>
      </Popover.Content>
    </Popover.Root>
  );
};
